import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import Loader from 'shared/components/Loader';

function BlankLayoutRoute({ component: Component, ...rest }: any) {
	const loader = <Loader />;

	const Structure = (
		<Suspense fallback={loader}>
			<Component />
		</Suspense>
	);

	return <Route {...rest} render={() => <>{Structure}</>} />;
}

export default BlankLayoutRoute;
